
import Scrollbar from 'smooth-scrollbar';
import {WOW} from 'wowjs';
import Cursor from './Cursor';
import AlertMessage from './AlertMessage';
import ModalVideo from './ModalVideo';
import Footer from './Footer';
import Header from './Header';
import Preload from './lib/Preload';

'use strict'

class App {
    constructor() {
        ['https://cdnjs.cloudflare.com/ajax/libs/vimeo-player/2.18.0/player.min.js', 'https://www.youtube.com/iframe_api'].map(function(src){
            var tag = document.createElement('script');
            tag.src = src;
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        });

        let loader = document.getElementById('loader_progress');
        if(loader){
            let images = Array.from(document.querySelectorAll('.image-preload'));
            (new Preload()).run(images, (percent, image) => {
                loader.style.width = percent + '%';
            }).then((successMessage) => {
                loader.parentElement.remove();
            });
        }

        this.main = document.getElementById('app');
        
        this._section = Section != null ? new Section() : null;
        
        if(document.getElementById('header')){
            this._header = new Header();
        }

        if(document.getElementById('footer')){
            this._footer = new Footer();
        }
        
        App.scrollbar = Scrollbar.init(document.querySelector('.page'), {
            continuousScrolling: false,
            alwaysShowTracks: false,
        });        

        this._scrollController = document.getElementById('scrollController');
        this._scrollControllerContent = document.getElementById('scrollControllerContent');
        this._subscriptionSticky = document.getElementById('subscription_sticky');
        if(this._subscriptionSticky){
            this._subscriptionSticky.querySelector('.subscription-box__close').addEventListener('click', function(){
                this.parentNode.remove();
            });
        }
        
            
        this._updateSize();

        new Cursor();

        App.alertMessage = new AlertMessage();

        App.modalVideo = new ModalVideo();

        App.updateSize = this._updateSize.bind(this);
        
        setTimeout(()=>{
            App.wow = new WOW({
                boxClass: 'wow',
                offset: 0,
                // mobile: false,
                mobile: true,
                live: true,
                scrollContainer: '#scrollController'
            });
            
            App.wow.init();

            // For newly opened link (e.g in new tab)
            const hash = window.location.hash;
            
            if (hash) {
                const target = document.getElementById(hash.substring(1));
                if (target) {
                    setTimeout(() => {
                        App.scrollbar.scrollIntoView(target, {
                            offsetTop: -App.scrollbar.containerEl.scrollTop + document.querySelector('.header').offsetHeight,
                        });
                    }, 1500);
                }
            }

            // For opening link in the same page
            window.addEventListener('hashchange', () => {
                const hash = window.location.hash;

                if (hash) {
                    const target = document.getElementById(hash.substring(1));
                    if (target) {

                        setTimeout(() => {
                            this._header.closeMenu();
                            App.scrollbar.scrollIntoView(target, {
                                offsetTop: -App.scrollbar.containerEl.scrollTop + document.querySelector('.header').offsetHeight,
                            });
                        }, 0);
                    }
                }
            }, false);
        }, 0);

        // Mobiles arrow submenu navigation
        [...document.querySelectorAll('.navigation__mobile-arrow')].forEach((arrow) => arrow.addEventListener('click', (e) => {
            const item = e.target.closest('.navigation__item');
            item.classList.toggle('navigation__item--open');
        }));
               
        
        document.body.classList.remove('loading');
                
        App.scrollbar.addListener(this._onScrollbarEvent.bind(this));
        window.addEventListener('resize', this._onResize.bind(this));
        
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            // console.log('resize');
        }, 750);
 
    }
    
    _onScrollbarEvent(e){
        let scroll = App.scrollbar.scrollTop;
        this._scrollController.scrollTop = scroll;
        
        // Header sticky
        if (scroll > 0 && !this._header.main.classList.contains('header--sticky')) {
            this._header.main.classList.add('header--sticky');
        } else if (scroll < 1 && this._header.main.classList.contains('header--sticky')) {
            this._header.main.classList.remove('header--sticky');
        }
        
        // Newsletter subscription sticky if exist
        if (this._subscriptionSticky) {
            let fpos = this._footer.getElement().offsetTop;
            let lpos = this._subscriptionSticky.offsetTop + this._subscriptionSticky.offsetHeight + scroll;

            //console.log('this._footer:', fpos, '-', lpos);
            if (scroll > 0 && lpos < fpos) {
                this._subscriptionSticky.classList.add('subscription-box--show');
            } else { 
                // if (scroll < 1 && this._subscriptionSticky.classList.contains('subscription-box--show')) {
                this._subscriptionSticky.classList.remove('subscription-box--show');
            }
        }
    }

    _onResize(e){
        this._updateSize();
    }

    _updateSize(){
        this._scrollControllerContent.style.height = document.querySelector('.scroll-content').scrollHeight + 'px';
    }

    
}

export default App;